import React, { useCallback, useContext, useEffect } from 'react'
import { Button, RenderFields } from 'components/Form'
import { CreateAssessmentDefContext } from './CreateAssessmentDefContext'
import createAssessmentDefHooks from './hooks'

const CreateAssessmentDef = () => {
    const { goNextStep } = useContext(CreateAssessmentDefContext)

    const { fields1, fields2, fields3 } = createAssessmentDefHooks.useFormFields()

    return (
        <div className='wrap-form'>
            <div className='sections'>
                <div className='section section1-fields'>
                    <div className='section-title'>
                        {"פרטי מבדק"}
                    </div>
                    <div className='fields'>
                        <RenderFields fields={fields1} />
                    </div>
                    <div className='section-title'>
                        {"טווח גילאים"}
                    </div>
                    <div className='fields fields2'>
                        <RenderFields fields={fields2} />
                    </div>
                </div>
                <div className='section section3-fields'>
                    <div className='section'>
                        <div className='section-title'>
                            {"פרטי יוצר ובעלות"}
                        </div>
                        <div className='fields'>
                            <RenderFields fields={fields3} />
                        </div>
                    </div>
                    <div className='continue-button'>
                        <Button
                            size="small"
                            label="המשך"
                            color="dark"
                            action={() => goNextStep()}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateAssessmentDef